import React from "react";
import styles from "./ModalAuthRegInput.module.scss";

interface ModalAuthRegInputProps {
  isEmail?: boolean;
  isPassword?: boolean;
  isTel?: boolean;
  label: string;
  title: string;
  required?: boolean;
  onChange: (value: string) => void;
}

const ModalAuthRegInput: React.FC<ModalAuthRegInputProps> = ({
  isEmail,
  isPassword,
  isTel,
  label,
  title,
  required,
  onChange,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [value, setValue] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  const syncValue = React.useCallback(
    (raw: string) => {
      setValue(raw);
      onChange(raw);
    },
    [onChange]
  );


  React.useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const syncFromDom = () => {
      const domValue = input.value;
      if (domValue) syncValue(domValue);
    };

    syncFromDom();
    const t1 = window.setTimeout(syncFromDom, 100);
    const t2 = window.setTimeout(syncFromDom, 500);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [syncValue]);

  const validateRequired = (val: string) => {
    if (!val.trim()) return "Поле не может быть пустым";
    return "";
  };

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email.trim())) return "Введите корректный email";
    return "";
  };

  const validateTel = (tel: string) => {
    const regex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
    if (!regex.test(tel)) return "Введите корректный номер телефона";
    return "";
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    syncValue(e.target.value);
    if (errorMessage) setErrorMessage("");
  };

  const handleBlur = () => {
    let error = "";
    if (required) error = validateRequired(value);
    if (!error && isEmail) error = validateEmail(value);
    if (!error && isTel) error = validateTel(value);
    setErrorMessage(error);
  };

  const autoComplete = isPassword
    ? "current-password"
    : isEmail
      ? "username"
      : isTel
        ? "tel"
        : "off";

  return (
    <div className={styles.inputWrapper}>
      <label htmlFor={label}>{title}</label>
      <input
        ref={inputRef}
        name={label}
        type={isTel ? "tel" : isEmail ? "email" : isPassword ? "password" : "text"}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        id={label}
        autoComplete={autoComplete}
        required={required}
      />
      {errorMessage && <div className={styles.error}>{errorMessage}</div>}
    </div>
  );
};

export default ModalAuthRegInput;
